import React from "react";
import { makeStyles, InputLabel, TextField, OutlinedInput, InputAdornment, IconButton, Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    label: {
        marginBottom: '12px'
    }
}));

export default function InputKeyGenerator(props) {
    const classes = useStyles();

    
    function generateKey () {
      const size=20
      let result = [];
      let hexRef = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
    
      for (let n = 0; n < size; n++) {
        result.push(hexRef[Math.floor(Math.random() * 16)]);
      }
      return result.join('');
    }

    return (
        <>
            {props.label ? <InputLabel htmlFor={props.id} className={classes.label}>{props.label}</InputLabel> : null}
            <OutlinedInput
                type="text"
                fullWidth
                id={props.id}
                value={props.value}
                onChange={(e) => { props.onChange(e.target.value) }}
                disabled={props.disabled}
                error={props.hasError}
                readOnly={props.readOnly}
                endAdornment={
                    <InputAdornment position="end">
                        <Button variant="outlined" color="primary" size="small" onClick={() => {generateKey()}}>
                            Generate
                        </Button>
                    </InputAdornment>
                }
            />
            {
                props.hasError ?
                    <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error" id={props.id + "-helper-text"}>{props.errorText}</p> : null
            }

        </>
    )
}